// istanbul ignore file
import React from 'react'
import { getAlertsNotificationDataByFilter, getHealthSummaryService, getacknowledgeNotificationService, getclearNotiicationService } from '../../device-dashboard/redux/actionCreator'
import { type ConnectedProps, connect, useSelector } from 'react-redux'
import { type RootState } from '../../../store'
import { type AlertsNotificationDataState } from '../../device-dashboard/redux/getNotificationByFilterSlice'
import { type clearNotificationDataState } from '../../device-dashboard/redux/clearNotificationServiceSlice'
import { type acknowledgeNotificationDataState } from '../../device-dashboard/redux/acknowledgeNotificationServiceSlice'
import Modal from '../../../components/Modal'
import CloseIcon from '@mui/icons-material/Close'
import { Button } from '../../../components/Button'
import { Box, Checkbox, CircularProgress, FormControl, FormControlLabel, FormGroup, Radio, RadioGroup, Typography } from '@mui/material'
import FilterIcon from '../../../assets/filterIcon.png'
import lowBadge from '../../../assets/lowBadge.svg'
import highBadge from '../../../assets/highBadge.svg'
import UrgentBadge from '../../../assets/mediumBadge.svg'
import efficiency from '../../../assets/Efficiency.svg'
import reliability from '../../../assets/Reliability.svg'
import safety from '../../../assets/Safety.svg'
import none from '../../../assets/None.svg'
import refresh from '../../../assets/refresh.svg'
import AuthError from '../../../components/ErrorComponents/AuthError'
import { type Option } from '../../../components/GenXDropdown'
import moment from 'moment-timezone'
import './assetDashboard.css'
import { getOperationPermissions } from '../../dashboard/redux/actionCreator'
import { type OperationPermissionState } from '../../dashboard/redux/operationPermissionSlice'
import { useAuth } from 'react-oidc-context'

export const getStatusIcons = (status: string): JSX.Element => {
  switch (status) {
    case 'low':
      return <img src={lowBadge} />
    case 'urgent':
      return <img src={UrgentBadge} />
    case 'high':
      return <img src={highBadge} />
    default:
      return <img src={lowBadge} />
  }
}

export const getLabelIcons = (status: string): JSX.Element => {
  switch (status) {
    case 'Safety':
      return <img src={safety} />
    case 'Reliability':
      return <img src={reliability} />
    case 'Efficiency':
      return <img src={efficiency} />
    case 'None':
      return <img src={none} />
    default:
      return <img src={safety} />
  }
}

const alertNotification = (props: AllProps): JSX.Element => {
  const [showSuccessPopUp, setshowSuccessPopUp] = React.useState(false)
  const [showSuccessACKPopUp, setshowSuccessACKPopUp] = React.useState(false)
  const [showfilter, setShowFilter] = React.useState(false)
  const [sortOrder, setSortOrder] = React.useState('desc')
  const [selectedOption, setSelectedOption] = React.useState('All')
  const [selectedCheckboxHigh, setSelectedCheckHigh] = React.useState(false)
  const [selectedCheckboxUrgent, setSelectedCheckUrgent] = React.useState(false)
  const [selectedCheckboxLow, setSelectedCheckLow] = React.useState(false)
  const [selectedCheckboxSafety, setSelectedCheckSafety] = React.useState(false)
  const [selectedCheckboxReliability, setSelectedCheckReliability] = React.useState(false)
  const [selectedCheckboxEfficiency, setSelectedCheckEfficiency] = React.useState(false)
  const [selectedCheckboxNone, setSelectedCheckNone] = React.useState(false)
  const [selectedOptionHigh, setSelectedOptionHigh] = React.useState('')
  const [selectedOptionUrgent, setSelectedOptionUrgent] = React.useState('')
  const [selectedOptionLow, setSelectedOptionLow] = React.useState('')
  const [selectedOptionSafety, setSelectedOptionSafety] = React.useState<Option | null>(null)
  const [selectedOptionReliability, setSelectedOptionReliability] = React.useState<Option | null>(null)
  const [selectedOptionEfficiency, setSelectedOptionEfficiency] = React.useState<Option | null>(null)
  const [selectedOptionNone, setSelectedOptionNone] = React.useState<Option | null>(null)
  const clearNotificationStatus = useSelector((state: RootState) => state.ClearNotificationData)
  const acknowledgeNotificationStatus = useSelector((state: RootState) => state.AcknowledgeNotificationData)
  const notificationData = useSelector((state: RootState) => state.AlertsNotificationData.AlertsNotificationData)
  const notificationDataStatus = useSelector((state: RootState) => state.AlertsNotificationData)

  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const operationPermissions: OperationPermissionState = useSelector((state: RootState) => state.operationPermissions)
  const auth = useAuth()

  React.useEffect(() => {
    (!operationPermissions.updated && props.getOperationPermissions(auth.user?.profile.sub as string))
  }, [])

  const handleClearNotificationWitFailure = (): JSX.Element => {
    if (clearNotificationStatus.httpStatus === 200) {
      return (
            <Modal
              buttonTypeNegative='hollow'
              title={'Clear Notification'}
              LabelPositive={'Ok'}
              onClickPositive={() => { handleOkandClose() }}
              onClose={() => { handleOkandClose() }}
            >
              <p style={{ paddingTop: '1.2em', fontSize: '18px' }}>
                {clearNotificationStatus.httpStatus === 200 ? 'Successfully Cleared' : clearNotificationStatus.loadingError}
              </p>
            </Modal>
      )
    } else if (clearNotificationStatus.isLoading) {
      return (
            <Modal title={'Loading...'}>
              <div className='CircularprogressAmi'>
                <CircularProgress />
              </div>
            </Modal>
      )
    } else if (clearNotificationStatus.httpStatus === 400) {
      return (
            <Modal buttonTypeNegative='hollow'
              title={'Clear Notification'}
              LabelPositive={'Ok'}
              onClickPositive={() => { handleOkandClose() }}
              onClose={() => { handleOkandClose() }}
            >
              <p style={{ paddingTop: '1.2em' }}>
                {clearNotificationStatus.loadingError}
              </p>
            </Modal>
      )
    } else if (clearNotificationStatus.httpStatus === 401) {
      return (
            <div className='authError'><AuthError errorMessage='Unauthorized' /></div>
      )
    } else if (clearNotificationStatus.httpStatus === 404) {
      return (
            <Modal
              buttonTypeNegative='hollow'
              title={'Clear Notification'}
              LabelPositive={'Ok'}
              onClickPositive={() => {
                setshowSuccessPopUp(false)
              }}
              onClose={() => {
                setshowSuccessPopUp(false)
              }}
            >
              <p style={{ paddingTop: '1.2em' }}>
                {clearNotificationStatus?.loadingError} (Status: {clearNotificationStatus?.httpStatus})
              </p>
            </Modal>
      )
    } else if (clearNotificationStatus.httpStatus === 403) {
      return (
            <div className='authError'><AuthError errorMessage='accessForbidden' /></div>
      )
    } else {
      return (
            <Modal
              buttonTypeNegative='hollow'
              title={'Clear Notification'}
              LabelPositive={'Ok'}
              onClickPositive={() => {
                setshowSuccessPopUp(false)
              }}
              onClose={() => {
                setshowSuccessPopUp(false)
              }}
            >
              <p style={{ paddingTop: '1.2em' }}>
                {clearNotificationStatus.httpStatus}
              </p>
            </Modal>
      )
    }
  }

  const handleAckNotificationWitFailure = (): JSX.Element => {
    if (acknowledgeNotificationStatus.httpStatus === 200) {
      return (
            <Modal
              buttonTypeNegative='hollow'
              title={'Acknowledge Notification'}
              LabelPositive={'Ok'}
              onClickPositive={() => { handleOkandCloseack() }}
              onClose={() => { handleOkandCloseack() }}
            >
              <p style={{ color: '#fffff', paddingTop: '1.2em', fontSize: '18px' }}>
                {acknowledgeNotificationStatus.httpStatus === 200 ? 'Successfully Acknowledged' : acknowledgeNotificationStatus.loadingError}
              </p>
            </Modal>
      )
    } else if (acknowledgeNotificationStatus.isLoading) {
      return (
            <Modal title={'Loading...'}>
              <div className='CircularprogressAmi'>
                <CircularProgress />
              </div>
            </Modal>
      )
    } else if (acknowledgeNotificationStatus.httpStatus === 400) {
      return (
            <Modal buttonTypeNegative='hollow'
              title={'Acknowledge Notification'}
              LabelPositive={'Ok'}
              onClickPositive={() => { handleOkandCloseack() }}
              onClose={() => { handleOkandCloseack() }}
            >
              <p style={{ paddingTop: '1.2em' }}>
                {acknowledgeNotificationStatus.loadingError}
              </p>
            </Modal>
      )
    } else if (acknowledgeNotificationStatus.httpStatus === 401) {
      return (
            <div className='authError'><AuthError errorMessage='Unauthorized' /></div>
      )
    } else if (acknowledgeNotificationStatus.httpStatus === 403) {
      return (
            <div className='authError'><AuthError errorMessage='accessForbidden' /></div>
      )
    } else if (acknowledgeNotificationStatus.httpStatus === 404) {
      return (
            <Modal
              buttonTypeNegative='hollow'
              title={'Acknowledge Notification'}
              LabelPositive={'Ok'}
              onClickPositive={() => {
                setshowSuccessACKPopUp(false)
              }}
              onClose={() => {
                setshowSuccessACKPopUp(false)
              }}
            >
              <p style={{ paddingTop: '1.2em' }}>
              {acknowledgeNotificationStatus?.loadingError} (Status: {acknowledgeNotificationStatus?.httpStatus})
              </p>
            </Modal>
      )
    } else {
      return (
            <Modal
              buttonTypeNegative='hollow'
              title={'Acknowledge Notification'}
              LabelPositive={'Ok'}
              onClickPositive={() => {
                setshowSuccessACKPopUp(false)
              }}
              onClose={() => {
                setshowSuccessACKPopUp(false)
              }}
            >
              <p style={{ paddingTop: '1.2em' }}>
                {acknowledgeNotificationStatus.loadingError}
              </p>
            </Modal>
      )
    }
  }

  const handleAcknowledgeNotification = (alarmId: string): void => {
    props.getacknowledgeNotificationService(alarmId)
    setshowSuccessACKPopUp(true)
    handeleAlertNotificationUpdate()
  }

  const handleTable = (): JSX.Element => {
    if (notificationData !== undefined && notificationDataStatus.httpStatus === 200) {
      return (
        <div className='notification-data'>
        {notificationData?.map((item, index) => (
            <div key={index} style={{ marginBottom: '20px' }}>
              <div className='notification-Priority-icon'>
                <span className='notification-header-title'>{getStatusIcons(item.severity)} <span className='notification-label-name' >{getLabelIcons(item.alarmLabelName)}</span></span>
              </div>
              <div className='notification-data-details'>
                <ul className='notificationUL' style={{ paddingLeft: '20px', color: '#fff' }}>
                  <li style={{ fontWeight: 'bold' }}>Hierarchy : { item.hierarchy }</li>
                  <li>Return to Normal : {item.status === 'RTN' ? item.returnToNormal : '-'}</li>
                  <li>Return to Normal Time : { item.status === 'RTN' ? moment.utc(item.rtnRaisedAt).tz(userTimezone).format('YYYY-MM-DD hh:mm:ss A') : '-'}</li>
                  <li>Asset Name : {item.assetName}</li>
                  <li>Parameter Name : {item.parameterName}</li>
                  <li>Triggered Value : {item.currentValue}</li>
                  <li>Set Point Value : {item.setPoint}</li>
                  <li>Recommended Actions : {item.recommendedActions}</li>
                  <li>Status: {item.status}</li>
                  <li>Alarm Raised At : { item.alarmRaisedAt !== null ? moment.utc(item.alarmRaisedAt).tz(userTimezone).format('YYYY-MM-DD hh:mm:ss A') : ''}</li>
                </ul>
                <div className='notification-buttons'>
                  {
                    operationPermissions.permissions.can_delete_tiq_alerts
                      ? <Button
                          onClick={() => { handleClearNotification(item.alarmId) }}
                          className={`noti-btn ${item.returnToNormal !== 'RTN' ? 'disabled' : ''}`}
                          type='hollow'
                          disabled={item.returnToNormal !== 'RTN'}
                          >
                          Clear
                        </Button>
                      : <></>
                  }
                  {
                    operationPermissions.permissions.can_modify_tiq_alerts
                      ? <Button
                          onClick={() => { handleAcknowledgeNotification(item.alarmId) }}
                          className={`noti-btn ${item.acknowledged !== null && item.acknowledged ? '' : 'blinking'} ${(item.returnToNormal === 'RTN' || item.acknowledged) ? 'disabled' : ''}`}
                          disabled={item.returnToNormal === 'RTN'}
                        >
                          Acknowledge
                        </Button>
                      : <></>
                  }
                </div>
              </div>
            </div>
        ))}
          </div>
      )
    } else if (notificationDataStatus.isLoading) {
      return (
        <div className="CircularprogressAmi">
          <CircularProgress />
        </div>
      )
    } else if (notificationDataStatus.httpStatus === 401) {
      return (
        <div className="authError">
          <AuthError className="paramterError" errorMessage="Unauthorized" />
        </div>
      )
    } else if (notificationDataStatus.httpStatus === 403) {
      return (
        <div className="authError">
          <AuthError className="paramterError" errorMessage="accessForbidden" />
        </div>
      )
    } else if (notificationDataStatus.httpStatus === 404) {
      return (
        <div className="authError">
          <AuthError className="paramterError" errorMessage="NoDataPresent" />
        </div>
      )
    } else {
      return (
        <div className="authError">
          <AuthError
            className="paramterError"
            errorMessage="cannotFetch"
            retry={handeleAlertNotificationUpdate}
          />
        </div>
      )
    }
  }

  const handleClearNotification = (alarmId: string): void => {
    props.getclearNotiicationService(alarmId)
    setshowSuccessPopUp(true)
    handeleAlertNotificationUpdate()
  }

  const handleOkandClose = (): void => {
    if (clearNotificationStatus.httpStatus === 200) {
      setshowSuccessPopUp(false)
    } else {
      setshowSuccessPopUp(false)
    }
  }

  const handleOkandCloseack = (): void => {
    if (clearNotificationStatus.httpStatus === 200) {
      setshowSuccessACKPopUp(false)
    } else {
      setshowSuccessACKPopUp(false)
    }
  }

  const clearAllFilters = (): void => {
    setSelectedOption('')
    setSelectedOptionLow('')
    setSelectedOptionUrgent('')
    setSelectedOptionHigh('')
    setSelectedCheckHigh(false)
    setSelectedCheckUrgent(false)
    setSelectedCheckLow(false)
    setSelectedCheckSafety(false)
    setSelectedCheckReliability(false)
    setSelectedCheckEfficiency(false)
    setSelectedCheckNone(false)
    setSelectedOptionSafety(null)
    setSelectedOptionReliability(null)
    setSelectedOptionEfficiency(null)
    setSelectedOptionNone(null)
    setShowFilter(false)
  }

  const handleIconClick = (): void => {
    props.setOpenFilter(true)
    if (window.location.pathname.includes('/device-dashboard')) {
      props.callGetHealthSummaryService(props.siteId, props.assetId, props.deviceId)
    } else if (window.location.pathname.includes('/asset-dashboard')) {
      props.callGetHealthSummaryService(props.siteId, props.assetId, '')
    }
    props.getAlertsNotificationDataByFilter(props.siteId, props.assetId, props.deviceId, '', '', '', sortOrder !== '' ? 'desc' : 'asc')
  }

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSelectedOption(event.target.value)
  }

  const handleCheckboxChangeHigh = (): void => {
    setSelectedCheckHigh((prevSelected) => {
      const newSelected = !prevSelected
      if (newSelected) {
        setSelectedOptionHigh('high')
      } else {
        setSelectedOptionHigh('')
      }
      return newSelected
    })
  }

  const handleCheckboxChangeUrgent = (): void => {
    setSelectedCheckUrgent((prevSelected) => {
      const newSelected = !prevSelected
      if (newSelected) {
        setSelectedOptionUrgent('urgent')
      } else {
        setSelectedOptionUrgent('')
      }
      return newSelected
    })
  }

  const handleCheckboxChangeLow = (): void => {
    setSelectedCheckLow((prevSelected) => {
      const newSelected = !prevSelected
      if (newSelected) {
        setSelectedOptionLow('low')
      } else {
        setSelectedOptionLow('')
      }
      return newSelected
    })
  }

  const handleCheckboxChangeSafety = (name: string, value: string): void => {
    setSelectedCheckSafety((prevSelected) => {
      const newSelected = !prevSelected
      if (newSelected) {
        setSelectedOptionSafety({ label: name, value })
      } else {
        setSelectedOptionSafety(null)
      }
      return newSelected
    })
  }

  const handleCheckboxChangeReliability = (name: string, value: string): void => {
    setSelectedCheckReliability((prevSelected) => {
      const newSelected = !prevSelected
      if (newSelected) {
        setSelectedOptionReliability({ label: name, value })
      } else {
        setSelectedOptionReliability(null)
      }
      return newSelected
    })
  }

  const handleCheckboxChangeEfficiency = (name: string, value: string): void => {
    setSelectedCheckEfficiency((prevSelected) => {
      const newSelected = !prevSelected
      if (newSelected) {
        setSelectedOptionEfficiency({ label: name, value })
      } else {
        setSelectedOptionEfficiency(null)
      }
      return newSelected
    })
  }

  const handleCheckboxChangeNone = (name: string, value: string): void => {
    setSelectedCheckNone((prevSelected) => {
      const newSelected = !prevSelected
      if (newSelected) {
        setSelectedOptionNone({ label: name, value })
      } else {
        setSelectedOptionNone(null)
      }
      return newSelected
    })
  }

  const handeleAlertNotificationUpdate = (): void => {
    const formattedString = [selectedOptionHigh, selectedOptionUrgent, selectedOptionLow]
      .filter(option => option !== '')
      .join(',')

    const selectedLabels = [selectedOptionSafety?.value, selectedOptionReliability?.value, selectedOptionEfficiency?.value, selectedOptionNone?.value]
      .filter(option => (option ?? '').trim() !== '')
      .join(',')
    props.getAlertsNotificationDataByFilter(props.siteId, props.assetId, props.deviceId, formattedString, selectedOption === 'All' ? '' : selectedOption, selectedLabels, sortOrder)
  }

  const handleSort = (): void => {
    const formattedString = [selectedOptionHigh, selectedOptionUrgent, selectedOptionLow]
      .filter(option => option !== '')
      .join(',')

    const selectedLabels = [selectedOptionSafety?.value, selectedOptionReliability?.value, selectedOptionEfficiency?.value, selectedOptionNone?.value]
      .filter(option => (option ?? '').trim() !== '')
      .join(',')
    const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc'
    setSortOrder(newSortOrder)
    props.getAlertsNotificationDataByFilter(props.siteId, props.assetId, props.deviceId, formattedString, selectedOption === 'All' ? '' : selectedOption, selectedLabels, newSortOrder)
  }

  return (
    <>
      <div className='notification-main' >
                <div className='notification-header-container'>
                  <Typography className="admin-card-titles device-card-title">NOTIFICATIONS</Typography>
                  <span style={{ marginTop: '15px', cursor: 'pointer', position: 'absolute', top: '16px', right: '20px', color: '#fff' }}
                  onClick={() => {
                    props.setOpenFilter(false)
                    clearAllFilters()
                  }}>
                    <CloseIcon/></span>
                </div>
                <div className='notification-filter'>
                  <Button onClick={() => { handleSort() }} className='filter-btn-notification' type='hollow'>
                    <img src={FilterIcon} height={20} width={20} style={{ marginLeft: '-20px', marginRight: '18px', paddingTop: '5px' }} />
                    Sort {sortOrder === 'asc' ? '▲' : '▼'}
                  </Button><Button onClick={() => { setShowFilter(true) }} className='filter-btn-notification' type='hollow'>Filter</Button>
                  <Button onClick={handleIconClick} className='refresh-btn-notification' type='hollow' ><img src={refresh} height={20} width={20} style={{ marginLeft: '-20px', marginRight: '18px', paddingTop: '5px' }} /></Button>
                </div>
        { showfilter &&
          <div
            style={{
              padding: '12px 0px',
              color: '#d0d0d0'
            }}
          >
            { selectedOption === null
            // && selectedCheckboxes.high === false
              ? (
                  'No filters applied'
                )
              : (
                <div style={{ display: 'ruby' }} className="classNAme">
                  <>
                    {selectedOption !== '' &&
                      <div className="box">
                        {' '}
                        {' '}
                        {selectedOption}
                      </div>
                    }
                    {selectedOptionHigh !== '' &&
                      <div className="box">
                        {' '}
                        {selectedOptionHigh}
                      </div>
                    }
                    {selectedOptionUrgent !== '' &&
                      <div className="box">
                        {' '}
                        {selectedOptionUrgent}
                      </div>
                    }
                    {selectedOptionLow !== '' &&
                      <div className="box">
                        {' '}
                        {selectedOptionLow}
                      </div>
                    }
                    {selectedOptionSafety !== null &&
                      <div className="box">
                        {' '}
                        {selectedOptionSafety.label}
                      </div>
                    }
                    {selectedOptionReliability !== null &&
                      <div className="box">
                        {' '}
                        {selectedOptionReliability.label}
                      </div>
                    }
                    {selectedOptionEfficiency !== null &&
                      <div className="box">
                        {' '}
                        {selectedOptionEfficiency.label}
                      </div>
                    }
                    {selectedOptionNone !== null &&
                      <div className="box">
                        {' '}
                        {selectedOptionNone?.label}
                      </div>
                    }
                  </>
                  <em
                    onClick={() => {
                      clearAllFilters()
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    Clear Filters{' '}
                  </em>
                </div>
                )}
          </div>
        }
        { showfilter &&
                <div className='notification-filter-section'>
                <Box className='filter-box' display="flex" justifyContent="space-between" p={2}>
                    <Box style={{ width: '130px' }}>
                      <Typography variant="h6">Select Alert</Typography>
                      <FormControl component="fieldset">
                        <RadioGroup
                          aria-label="selection"
                          name="selection"
                          value={selectedOption}
                          onChange={handleRadioChange}
                        >
                          <FormControlLabel value="All" control={<Radio />} label="All" />
                          <FormControlLabel value="active" control={<Radio />} label="Active" />
                          <FormControlLabel value="rtn" control={<Radio />} label="Return to Normal" />
                        </RadioGroup>
                      </FormControl>
                      <Button onClick={handeleAlertNotificationUpdate} className='noti-btn'>Update</Button>
                    </Box>
                    <Box>
                      <Typography variant="h6">Select Severities</Typography>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedCheckboxHigh}
                              onChange={handleCheckboxChangeHigh}
                              name="high"
                            />
                          }
                          label="High"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedCheckboxUrgent}
                              onChange={handleCheckboxChangeUrgent}
                              name="urgent"
                            />
                          }
                          label="Urgent"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedCheckboxLow}
                              onChange={handleCheckboxChangeLow}
                              name="low"
                            />
                          }
                          label="Low"
                        />
                      </FormGroup>
                    </Box>
                    <Box>
                     <Typography variant="h6">Select Label</Typography>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedCheckboxSafety}
                              onChange={(e) => { handleCheckboxChangeSafety(e.target.name, e.target.value) }}
                              name='Safety'
                              value='39ce3eec-05ab-454a-8061-467025c8366f'
                            />
                          }
                          label="Safety"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedCheckboxReliability}
                              onChange={(e) => { handleCheckboxChangeReliability(e.target.name, e.target.value) }}
                              name="Reliability"
                              value='18189008-95c3-4c12-a928-247091160e16'
                            />
                          }
                          label="Reliability"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedCheckboxEfficiency}
                              onChange={(e) => { handleCheckboxChangeEfficiency(e.target.name, e.target.value) }}
                              name="Efficiency"
                              value='01c9f476-0acd-490b-bff0-a074c7da0923'
                            />
                          }
                          label="Efficiency"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedCheckboxNone}
                              onChange={(e) => { handleCheckboxChangeNone(e.target.name, e.target.value) }}
                              name="None"
                              value='78bdd2c8-6fa1-4725-9e21-6dc991b9e9be'
                            />
                          }
                          label="None"
                        />
                      </FormGroup>
                    </Box>
                  </Box>
                </div>
                }
                {handleTable()}
                {showSuccessPopUp && handleClearNotificationWitFailure()}
                {showSuccessACKPopUp && handleAckNotificationWitFailure()}
      </div>
    </>
  )
}

interface DispatchToProps {
  getAlertsNotificationDataByFilter: (siteId: string, assetIds: string, deviceIds: string, severities: string, alertStatus: string, alarmLabelIds: string, sortOrder: string) => void
  getacknowledgeNotificationService: (deviced: string) => void
  getclearNotiicationService: (deviced: string) => void
  getOperationPermissions: (sub: string) => void
  callGetHealthSummaryService: (siteId: string, asseIds: string, deviceIds: string) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  getAlertsNotificationDataByFilter: (siteId: string, assetIds: string, deviceIds: string, severities: string, alertStatus: string, alarmLabelIds: string, sortOrder: string) => dispatch(getAlertsNotificationDataByFilter(siteId, assetIds, deviceIds, severities, alertStatus, alarmLabelIds, sortOrder)),
  getacknowledgeNotificationService: (deviced: string) =>
    dispatch(getacknowledgeNotificationService(deviced)),
  getclearNotiicationService: (deviced: string) =>
    dispatch(getclearNotiicationService(deviced)),
  getOperationPermissions: (sub: string) => dispatch(getOperationPermissions(sub)),
  callGetHealthSummaryService: (siteId: string, asseIds: string, deviceIds: string) => dispatch(getHealthSummaryService(siteId, asseIds, deviceIds))
})

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface StateToProps {
  alertNotificationData: AlertsNotificationDataState
  ClearNotificationData: clearNotificationDataState
  AcknowledgeNotificationData: acknowledgeNotificationDataState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  alertNotificationData: state.AlertsNotificationData,
  ClearNotificationData: state.ClearNotificationData,
  AcknowledgeNotificationData: state.AcknowledgeNotificationData
})
const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

interface ParentProps {
  setOpenFilter: (open: boolean) => void
  deviceId: string
  assetId: string
  siteId: string
}

type AllProps = PropsFromRedux & ParentProps

export default connector(alertNotification)
